import { Box } from "@mui/material";
import { AccordionDetails } from "@mui/material";
import { Property } from "csstype";

export const ImageWrapper = (
  props: React.ComponentProps<typeof Box> & {
    backgroundSize?: Property.BackgroundSize<string>;
  }
) => {
  const { backgroundSize = "cover", ...rest } = props;
  return (
    <Box
      component="div"
      sx={{
        width: "100px",
        m: "-6px -14px -6px -6px",
        "& .image": {
          position: "relative",
          p: 0,
          height: 0,
          overflow: "hidden",
          backgroundPosition: "center",
          backgroundSize: backgroundSize,
          backgroundRepeat: "no-repeat",
          boxSizing: "content-box",
          transition: "padding-bottom 0.5s ease-out",
          pb: "56.25%",
          width: "100%",
        },
      }}
      {...rest}
    />
  );
};

export const IconWrapper = (props: React.ComponentProps<typeof Box>) => (
  <Box
    component="div"
    sx={(theme) => ({
      color: theme.palette.text.primary,
      height: 30,
      width: 30,
      m: "-6px",
      borderRadius: "50%",
      position: "relative",
      "&:hover": {
        backgroundColor: "#a1a5ff",
      },
      svg: {
        position: "absolute",
        fontSize: 18,
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
      },
    })}
    {...props}
  />
);

export const ButtonIcon = (props: React.ComponentProps<typeof Box>) => (
  <Box
    component="span"
    sx={{
      mr: "7px",
      display: "inline-block",
      svg: { fontSize: 18 },
    }}
    {...props}
  />
);

export const AssetAccordionDetails = (
  props: React.ComponentProps<typeof AccordionDetails>
) => <AccordionDetails sx={{ pt: 3 }} {...props} />;
